import { useStaticQuery, graphql } from "gatsby"

export type Props = GatsbyTypes.StaticShopQuery

export const useShop = () => {
  const { shop } = useStaticQuery<GatsbyTypes.StaticShopQuery>(graphql`
    query StaticShop {
      shop: sanitySettingShop {
        name
        email
        weightUnit
        contactEmail
        currencyCode
        myshopifyDomain
        shipsToCountries
        enabledPresentmentCurrencies
        partnerDevelopment
        shopifyPlus
        displayName
        shopPolicies {
          body
          type
          url
        }
        primaryDomain {
          host
          url
          localization {
            country
            defaultLocale
            alternateLocales
          }
        }
        domains {
          host
          url
          localization {
            country
            defaultLocale
            alternateLocales
          }
        }
      }
    }
  `)

  return { shop }
}
